module.exports = __webpack_public_path__ + "img/carnet.a9214a4.svg";